import React from "react";
import "./pages.css";
import NutritionsLoop from "../components/nutritionsLoop";

function Nutrition({ handleLogout, deleteItem, user }) {
  return (
    <>
      <section className="mainSection">
        <nav className="hero">
          <h1 className="sr-only">Nutrition Guide</h1>
          <button onClick={handleLogout}>Log Out</button>
        </nav>

        <main>
          <NutritionsLoop deleteItem={deleteItem} user={user} />
        </main>
      </section>
    </>
  );
}

export default Nutrition;
